// extracted by mini-css-extract-plugin
module.exports = {"tagItem":"TagItem_tagItem__2DWDJ","value":"TagItem_value__-ZDsp","icon":"TagItem_icon__2b6XZ"};